import { render, staticRenderFns } from "./CompensatoryLeavesDashboard.vue?vue&type=template&id=b87cb14e"
import script from "./CompensatoryLeavesDashboard.vue?vue&type=script&lang=js"
export * from "./CompensatoryLeavesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports